import { render } from "./Archery.vue?vue&type=template&id=15ab2a12"
const script = {}

import exportComponent from "D:\\nextinnoivation-home\\yecheonmuseum-web-ar-release-ycg-1.0.0\\frontend\\user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__